import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'
import SERVICE from '../../utils/servicesUtil'

const register = (body) => axiosInstance.post(`${SERVICES.USER}`, body)
const login = (body) => axiosInstance.post(`${SERVICES.AUTH}/login`, body)
const loginSMS = (body) => axiosInstance.post(`${SERVICES.AUTH}/mfa/login/sms`, body)

const confirmEmail = (body) => axiosInstance.post(`${SERVICES.AUTH}/confirm-email`, body)
const confirmPhoneNumber = (body) => axiosInstance.post(`${SERVICES.AUTH}/confirm-phonenumber`, body)
const passwordRecovery = (email) => axiosInstance.post(`${SERVICES.USER}/initiate-password-recovery?email=${email}`)
const requestEmailCode = (body) => axiosInstance.post(`${SERVICES.AUTH}/request-email-validation-code`, body)
const requestPhoneCode = (body) => axiosInstance.post(`${SERVICES.AUTH}/request-phonenumber-validation-code`, body)
const contactSupport = (body) => axiosInstance.post(`${SERVICES.CONTACT}/support`, body)
const newPassword = (body) => axiosInstance.post(`${SERVICES.USER}/finalize-password-recovery`, body)
const getInviteData = ($InviteId) => axiosInstance.get(`${SERVICE.USER}/inviteregistrationinformation/${$InviteId}`)
const registerWithInvite = ($InviteId, body) => axiosInstance.post(`${SERVICE.USER}/withInvite/${$InviteId}`, body)
const getSession = (organizationId) => axiosInstance.get(`${SERVICE.USER}/getSession/${organizationId ? organizationId : ''}`)

const acceptInvite = (inviteId) => axiosInstance.post(`${SERVICE.INVITE}/${inviteId}/received`)

const loginExternalGoogle = (accessToken) => axiosInstance.post(`${SERVICES.AUTH}/external/google`, accessToken)
const loginExternalLinkedin = (accessToken) => axiosInstance.post(`${SERVICES.AUTH}/external/linkedin`, accessToken)

const updateBusinessProfile = (organizationId, body) => axiosInstance.patch(`${SERVICES.ORGANIZATION}/${organizationId}`, body)

const businessAreas = () => axiosInstance.get(`${SERVICES.ORGANIZATION}/items/business-areas`)
const getBusinessProfileList = () => axiosInstance.get(`${SERVICES.BUSINESS_PROFILES}`)

const getUserOrganizations = ($userId, $getDescendent, $page, $count, $name, $whitelabelOrganizationId) =>
  axiosInstance.get(`${SERVICES.USER}/organizations`, {
    params: {
      IncludeDescendentOrganizations: $getDescendent,
      Page: $page,
      Count: $count,
      Name: $name,
      WhitelabelOrganizationId: $whitelabelOrganizationId,
    },
  })

const selectOrganization = ($organizationId) => axiosInstance.post(`${SERVICES.AUTH}/select-organization`, { organizationId: $organizationId })

const enableUser = (userID) => axiosInstance.patch(`${SERVICES.USER}/${userID}/enable`)

export default {
  //user
  register,
  login,
  loginSMS,
  confirmEmail,
  confirmPhoneNumber,
  passwordRecovery,
  newPassword,
  requestEmailCode,
  requestPhoneCode,
  getInviteData,
  registerWithInvite,
  acceptInvite,
  contactSupport,
  getSession,

  //auth
  loginExternalGoogle,
  loginExternalLinkedin,

  //organization
  updateBusinessProfile,
  businessAreas,
  getBusinessProfileList,
  getUserOrganizations,
  selectOrganization,
  enableUser,
}
